import { render, staticRenderFns } from "./BlockBoolean.vue?vue&type=template&id=a55e4570&scoped=true"
import script from "./BlockBoolean.vue?vue&type=script&lang=js"
export * from "./BlockBoolean.vue?vue&type=script&lang=js"
import style0 from "./BlockBoolean.vue?vue&type=style&index=0&id=a55e4570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55e4570",
  null
  
)

export default component.exports